/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LandingRouteImport } from './routes/_landing'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LandingHomeRouteImport } from './routes/_landing/home'
import { Route as LandingAboutUsRouteImport } from './routes/_landing/aboutUs'
import { Route as ClientsTempulaRouteImport } from './routes/_clients/tempula'
import { Route as ClientsTempulaIndexRouteImport } from './routes/_clients/tempula/index'
import { Route as ClientsTempulaRoomRouteImport } from './routes/_clients/tempula/room'
import { Route as ClientsTempulaReceiptRouteImport } from './routes/_clients/tempula/receipt'
import { Route as ClientsTempulaRazorPayRouteImport } from './routes/_clients/tempula/razorPay'
import { Route as ClientsTempulaPaymentRouteImport } from './routes/_clients/tempula/payment'
import { Route as ClientsTempulaHomeRouteImport } from './routes/_clients/tempula/home'
import { Route as ClientsTempulaGalleryRouteImport } from './routes/_clients/tempula/gallery'
import { Route as ClientsTempulaContactRouteImport } from './routes/_clients/tempula/contact'
import { Route as ClientsTempulaBookRouteImport } from './routes/_clients/tempula/book'
import { Route as ClientsTempulaAboutUsRouteImport } from './routes/_clients/tempula/aboutUs'
import { Route as ClientsTempulaRoomsRoomIdRouteImport } from './routes/_clients/tempula/rooms/$roomId'

const LandingRoute = LandingRouteImport.update({
  id: '/_landing',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingHomeRoute = LandingHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => LandingRoute,
} as any)
const LandingAboutUsRoute = LandingAboutUsRouteImport.update({
  id: '/aboutUs',
  path: '/aboutUs',
  getParentRoute: () => LandingRoute,
} as any)
const ClientsTempulaRoute = ClientsTempulaRouteImport.update({
  id: '/_clients/tempula',
  path: '/tempula',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsTempulaIndexRoute = ClientsTempulaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaRoomRoute = ClientsTempulaRoomRouteImport.update({
  id: '/room',
  path: '/room',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaReceiptRoute = ClientsTempulaReceiptRouteImport.update({
  id: '/receipt',
  path: '/receipt',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaRazorPayRoute = ClientsTempulaRazorPayRouteImport.update({
  id: '/razorPay',
  path: '/razorPay',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaPaymentRoute = ClientsTempulaPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaHomeRoute = ClientsTempulaHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaGalleryRoute = ClientsTempulaGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaContactRoute = ClientsTempulaContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaBookRoute = ClientsTempulaBookRouteImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaAboutUsRoute = ClientsTempulaAboutUsRouteImport.update({
  id: '/aboutUs',
  path: '/aboutUs',
  getParentRoute: () => ClientsTempulaRoute,
} as any)
const ClientsTempulaRoomsRoomIdRoute =
  ClientsTempulaRoomsRoomIdRouteImport.update({
    id: '/rooms/$roomId',
    path: '/rooms/$roomId',
    getParentRoute: () => ClientsTempulaRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/tempula': typeof ClientsTempulaRouteWithChildren
  '/aboutUs': typeof LandingAboutUsRoute
  '/home': typeof LandingHomeRoute
  '/tempula/aboutUs': typeof ClientsTempulaAboutUsRoute
  '/tempula/book': typeof ClientsTempulaBookRoute
  '/tempula/contact': typeof ClientsTempulaContactRoute
  '/tempula/gallery': typeof ClientsTempulaGalleryRoute
  '/tempula/home': typeof ClientsTempulaHomeRoute
  '/tempula/payment': typeof ClientsTempulaPaymentRoute
  '/tempula/razorPay': typeof ClientsTempulaRazorPayRoute
  '/tempula/receipt': typeof ClientsTempulaReceiptRoute
  '/tempula/room': typeof ClientsTempulaRoomRoute
  '/tempula/': typeof ClientsTempulaIndexRoute
  '/tempula/rooms/$roomId': typeof ClientsTempulaRoomsRoomIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aboutUs': typeof LandingAboutUsRoute
  '/home': typeof LandingHomeRoute
  '/tempula/aboutUs': typeof ClientsTempulaAboutUsRoute
  '/tempula/book': typeof ClientsTempulaBookRoute
  '/tempula/contact': typeof ClientsTempulaContactRoute
  '/tempula/gallery': typeof ClientsTempulaGalleryRoute
  '/tempula/home': typeof ClientsTempulaHomeRoute
  '/tempula/payment': typeof ClientsTempulaPaymentRoute
  '/tempula/razorPay': typeof ClientsTempulaRazorPayRoute
  '/tempula/receipt': typeof ClientsTempulaReceiptRoute
  '/tempula/room': typeof ClientsTempulaRoomRoute
  '/tempula': typeof ClientsTempulaIndexRoute
  '/tempula/rooms/$roomId': typeof ClientsTempulaRoomsRoomIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_landing': typeof LandingRouteWithChildren
  '/_clients/tempula': typeof ClientsTempulaRouteWithChildren
  '/_landing/aboutUs': typeof LandingAboutUsRoute
  '/_landing/home': typeof LandingHomeRoute
  '/_clients/tempula/aboutUs': typeof ClientsTempulaAboutUsRoute
  '/_clients/tempula/book': typeof ClientsTempulaBookRoute
  '/_clients/tempula/contact': typeof ClientsTempulaContactRoute
  '/_clients/tempula/gallery': typeof ClientsTempulaGalleryRoute
  '/_clients/tempula/home': typeof ClientsTempulaHomeRoute
  '/_clients/tempula/payment': typeof ClientsTempulaPaymentRoute
  '/_clients/tempula/razorPay': typeof ClientsTempulaRazorPayRoute
  '/_clients/tempula/receipt': typeof ClientsTempulaReceiptRoute
  '/_clients/tempula/room': typeof ClientsTempulaRoomRoute
  '/_clients/tempula/': typeof ClientsTempulaIndexRoute
  '/_clients/tempula/rooms/$roomId': typeof ClientsTempulaRoomsRoomIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/tempula'
    | '/aboutUs'
    | '/home'
    | '/tempula/aboutUs'
    | '/tempula/book'
    | '/tempula/contact'
    | '/tempula/gallery'
    | '/tempula/home'
    | '/tempula/payment'
    | '/tempula/razorPay'
    | '/tempula/receipt'
    | '/tempula/room'
    | '/tempula/'
    | '/tempula/rooms/$roomId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aboutUs'
    | '/home'
    | '/tempula/aboutUs'
    | '/tempula/book'
    | '/tempula/contact'
    | '/tempula/gallery'
    | '/tempula/home'
    | '/tempula/payment'
    | '/tempula/razorPay'
    | '/tempula/receipt'
    | '/tempula/room'
    | '/tempula'
    | '/tempula/rooms/$roomId'
  id:
    | '__root__'
    | '/'
    | '/_landing'
    | '/_clients/tempula'
    | '/_landing/aboutUs'
    | '/_landing/home'
    | '/_clients/tempula/aboutUs'
    | '/_clients/tempula/book'
    | '/_clients/tempula/contact'
    | '/_clients/tempula/gallery'
    | '/_clients/tempula/home'
    | '/_clients/tempula/payment'
    | '/_clients/tempula/razorPay'
    | '/_clients/tempula/receipt'
    | '/_clients/tempula/room'
    | '/_clients/tempula/'
    | '/_clients/tempula/rooms/$roomId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LandingRoute: typeof LandingRouteWithChildren
  ClientsTempulaRoute: typeof ClientsTempulaRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_landing': {
      id: '/_landing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_landing/home': {
      id: '/_landing/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof LandingHomeRouteImport
      parentRoute: typeof LandingRoute
    }
    '/_landing/aboutUs': {
      id: '/_landing/aboutUs'
      path: '/aboutUs'
      fullPath: '/aboutUs'
      preLoaderRoute: typeof LandingAboutUsRouteImport
      parentRoute: typeof LandingRoute
    }
    '/_clients/tempula': {
      id: '/_clients/tempula'
      path: '/tempula'
      fullPath: '/tempula'
      preLoaderRoute: typeof ClientsTempulaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_clients/tempula/': {
      id: '/_clients/tempula/'
      path: '/'
      fullPath: '/tempula/'
      preLoaderRoute: typeof ClientsTempulaIndexRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/room': {
      id: '/_clients/tempula/room'
      path: '/room'
      fullPath: '/tempula/room'
      preLoaderRoute: typeof ClientsTempulaRoomRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/receipt': {
      id: '/_clients/tempula/receipt'
      path: '/receipt'
      fullPath: '/tempula/receipt'
      preLoaderRoute: typeof ClientsTempulaReceiptRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/razorPay': {
      id: '/_clients/tempula/razorPay'
      path: '/razorPay'
      fullPath: '/tempula/razorPay'
      preLoaderRoute: typeof ClientsTempulaRazorPayRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/payment': {
      id: '/_clients/tempula/payment'
      path: '/payment'
      fullPath: '/tempula/payment'
      preLoaderRoute: typeof ClientsTempulaPaymentRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/home': {
      id: '/_clients/tempula/home'
      path: '/home'
      fullPath: '/tempula/home'
      preLoaderRoute: typeof ClientsTempulaHomeRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/gallery': {
      id: '/_clients/tempula/gallery'
      path: '/gallery'
      fullPath: '/tempula/gallery'
      preLoaderRoute: typeof ClientsTempulaGalleryRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/contact': {
      id: '/_clients/tempula/contact'
      path: '/contact'
      fullPath: '/tempula/contact'
      preLoaderRoute: typeof ClientsTempulaContactRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/book': {
      id: '/_clients/tempula/book'
      path: '/book'
      fullPath: '/tempula/book'
      preLoaderRoute: typeof ClientsTempulaBookRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/aboutUs': {
      id: '/_clients/tempula/aboutUs'
      path: '/aboutUs'
      fullPath: '/tempula/aboutUs'
      preLoaderRoute: typeof ClientsTempulaAboutUsRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
    '/_clients/tempula/rooms/$roomId': {
      id: '/_clients/tempula/rooms/$roomId'
      path: '/rooms/$roomId'
      fullPath: '/tempula/rooms/$roomId'
      preLoaderRoute: typeof ClientsTempulaRoomsRoomIdRouteImport
      parentRoute: typeof ClientsTempulaRoute
    }
  }
}

interface LandingRouteChildren {
  LandingAboutUsRoute: typeof LandingAboutUsRoute
  LandingHomeRoute: typeof LandingHomeRoute
}

const LandingRouteChildren: LandingRouteChildren = {
  LandingAboutUsRoute: LandingAboutUsRoute,
  LandingHomeRoute: LandingHomeRoute,
}

const LandingRouteWithChildren =
  LandingRoute._addFileChildren(LandingRouteChildren)

interface ClientsTempulaRouteChildren {
  ClientsTempulaAboutUsRoute: typeof ClientsTempulaAboutUsRoute
  ClientsTempulaBookRoute: typeof ClientsTempulaBookRoute
  ClientsTempulaContactRoute: typeof ClientsTempulaContactRoute
  ClientsTempulaGalleryRoute: typeof ClientsTempulaGalleryRoute
  ClientsTempulaHomeRoute: typeof ClientsTempulaHomeRoute
  ClientsTempulaPaymentRoute: typeof ClientsTempulaPaymentRoute
  ClientsTempulaRazorPayRoute: typeof ClientsTempulaRazorPayRoute
  ClientsTempulaReceiptRoute: typeof ClientsTempulaReceiptRoute
  ClientsTempulaRoomRoute: typeof ClientsTempulaRoomRoute
  ClientsTempulaIndexRoute: typeof ClientsTempulaIndexRoute
  ClientsTempulaRoomsRoomIdRoute: typeof ClientsTempulaRoomsRoomIdRoute
}

const ClientsTempulaRouteChildren: ClientsTempulaRouteChildren = {
  ClientsTempulaAboutUsRoute: ClientsTempulaAboutUsRoute,
  ClientsTempulaBookRoute: ClientsTempulaBookRoute,
  ClientsTempulaContactRoute: ClientsTempulaContactRoute,
  ClientsTempulaGalleryRoute: ClientsTempulaGalleryRoute,
  ClientsTempulaHomeRoute: ClientsTempulaHomeRoute,
  ClientsTempulaPaymentRoute: ClientsTempulaPaymentRoute,
  ClientsTempulaRazorPayRoute: ClientsTempulaRazorPayRoute,
  ClientsTempulaReceiptRoute: ClientsTempulaReceiptRoute,
  ClientsTempulaRoomRoute: ClientsTempulaRoomRoute,
  ClientsTempulaIndexRoute: ClientsTempulaIndexRoute,
  ClientsTempulaRoomsRoomIdRoute: ClientsTempulaRoomsRoomIdRoute,
}

const ClientsTempulaRouteWithChildren = ClientsTempulaRoute._addFileChildren(
  ClientsTempulaRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LandingRoute: LandingRouteWithChildren,
  ClientsTempulaRoute: ClientsTempulaRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
